module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/css/admin.component.css
// module id = ./src/app/modules/admin/css/admin.component.css
// module chunks = main